import { apiClient } from './client'
import type {
  CreationLimits,
  PipelineCreateRequest,
  PipelineCreateResponse,
  PipelineDetail,
  PipelineFilters,
  PipelineListResponse,
  PipelineChildTasksResponse,
} from '@/lib/types/pipeline'

const BASE = '/agent-api/creation/pipelines'

export const pipelineApi = {
  // ── Create ─────────────────────────────────────────────────

  createPipeline: async (payload: PipelineCreateRequest) => {
    const response = await apiClient.post<PipelineCreateResponse>(
      BASE,
      payload,
    )
    return response.data
  },

  // ── Read ───────────────────────────────────────────────────

  getPipeline: async (id: string) => {
    const response = await apiClient.get<PipelineDetail>(
      `${BASE}/${id}`,
    )
    return response.data
  },

  listPipelines: async (params: PipelineFilters = {}) => {
    const response = await apiClient.get<PipelineListResponse>(
      BASE,
      { params },
    )
    return response.data
  },

  // ── Actions ────────────────────────────────────────────────

  cancelPipeline: async (id: string) => {
    const response = await apiClient.post<PipelineDetail>(
      `${BASE}/${id}/cancel`,
    )
    return response.data
  },

  retryPipeline: async (id: string) => {
    const response = await apiClient.post<PipelineDetail>(
      `${BASE}/${id}/retry`,
    )
    return response.data
  },

  deletePipeline: async (id: string) => {
    await apiClient.delete(`${BASE}/${id}`)
  },

  triggerPipeline: async (id: string) => {
    await apiClient.post(`${BASE}/${id}/run`)
  },

  getPipelineChildTasks: async (id: string) => {
    const response = await apiClient.get<PipelineChildTasksResponse>(
      `${BASE}/${id}/child-tasks`,
    )
    return response.data
  },

  // ── Concurrency limits (tenant-scoped) ──────────────────────

  getCreationLimits: async () => {
    const response = await apiClient.get<CreationLimits>(
      '/agent-api/creation/limits',
    )
    return response.data
  },
}
